// 전역 console 오버라이드 - VITE_DEV_MODE에 따라 console 메서드 제어
// VITE_DEV_MODE=true: 모든 로그 출력 (개발 모드)
// VITE_DEV_MODE=false: 로그 차단 (운영 모드)

// 원본 console 메서드 저장
const originalConsole = {
  log: console.log,
  info: console.info,
  warn: console.warn,
  error: console.error,
  debug: console.debug
};

// 환경 변수 확인
const isDevMode = import.meta.env.VITE_DEV_MODE === 'true';

// 빈 함수 (아무것도 출력하지 않음)
const noop = () => {};

// console 메서드 오버라이드
export function initConsoleOverride() {
  if (!isDevMode) {
    // 운영 모드: 모든 로그 완전 차단
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.warn = noop;
    console.error = noop;  // 에러도 차단
    
    // 마지막 메시지 (원본 console로 출력 후 차단)
    originalConsole.log('[CONSOLE] 운영 모드: 모든 로그 차단됨');
  }
  // 개발 모드에서는 아무것도 하지 않음 (원본 console 유지)
}

// 원본 console 복원 (필요시 사용)
export function restoreConsole() {
  console.log = originalConsole.log;
  console.info = originalConsole.info;
  console.warn = originalConsole.warn;
  console.error = originalConsole.error;
  console.debug = originalConsole.debug;
}

// 원본 console에 직접 접근 (필요시 사용)
export { originalConsole };